import React, { Suspense } from 'react'
import { lazyWithRetry } from '../../helper/lazyWithRetry'
import PageLoader from '../../component/Elements/pageLoader'

const WebShopTips = lazyWithRetry(() => import(/* webpackChunkName: "webshop-tips" */'../../component/WebShopTips'))

const WebShopTipsPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<WebShopTips />
		</Suspense>
	)
})

WebShopTipsPage.displayName = 'WebShopTipsPage'
export default WebShopTipsPage
